import { createFileRoute } from "@tanstack/react-router";
import { alternateLinkList } from "@/lib/i18n/locale";
import { RetailerGlobalPage } from "./legal.retailer-global";

export const Route = createFileRoute("/vi/legal/retailer-global")({
  head: () => ({
    meta: [{ title: "Hợp đồng Đại lý (Toàn cầu) — Banana Cards" }],
    links: alternateLinkList("/legal/retailer-global", "vi"),
  }),
  component: RetailerGlobalPage,
});